import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/index"
import AI from "../pages/AI/AI.vue";
import { getToken } from "@/util/auth";

Vue.use(VueRouter);
const whiteList = ['/login']

const routes = [
    // 配置项目启动默认页
    {
        path: '/',
        name: '',
        redirect: '/home'
    },

    {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
            title: '南宁交投智慧能源数字化管理平台'
        }
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            title: '登录'
        }
    },
    {
        path: "/AI",
        name: "AI",
        component: AI,
        meta: {
            title: '智惠大屏AI'
        }
    }
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});


router.beforeEach((to,from,next)=>{
    if(getToken()){
        if(to.path === '/login'){
            next({path : '/'})
        }else{
            next()
        }
    }else{
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login`)
        }
    }
})


export default router;
